module.exports = __webpack_public_path__ + "img/cjwt.d5191771.png";